import React, { useState, useRef, useEffect, useId } from "react";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import TabElement from "../../../Components/UiComponents/TabElement";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import Summary from "./Summary";
import Stakeholder from "./Stakeholder";
import Project from "./Project";
import { get, update } from "../../../Services/frameworkService";
import { findFrom } from "../../../Services/clientService";
import moment from "moment";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomer } from "../../../Services/customerServices";
import { getModulePermissions } from "../../../Services/pricingPlanService";
import { getField, getTable } from "../../../Services/tooltipService";
import { useProgramme } from "../../../Providers/ProgrammeContext";
import config from "../../../Utils/Constants.json";
import Loader from "../../../Components/UiComponents/Loader";
import { get as getCust } from "../../../Services/customerServices";
import { all as allUsers } from "../../../Services/userService";
import useScrollToTop from '../../../Components/UiComponents/useScrollToTop';
import { useSidebar } from "../../../Providers/SidebarContext";
import { useIsEdited } from "../../../Providers/IsEditedProvider";

const ProgrammeTabs = (props) => {
    const [items, setItems] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const { setIsEdited } = useIsEdited();
    const [frameworkId, setFrameworkId] = useState('');
    const [framework, setFramework] = useState('');
    const [appointmentType, setAppointmentType] = useState('');
    const [frameworkSize, setFrameworkSize] = useState('');
    const [frameworkType, setFrameworkType] = useState('');
    const [frameworkClassification, setFrameworkClassification] = useState([]);
    const { targetRef, scrollToTop } = useScrollToTop();
    const [durations, setDurations] = useState([]);
    const [region, setRegion] = useState([]);
    const [locations, setLocations] = useState([]);
    const [noOfCompetitors, setNoOfCompetitors] = useState([]);
    const [userDetails, setUserDetails] = useState([]);
    const [annualValueRational, setAnnualValueRational] = useState([]);
    const [averageProjectValue, setAverageProjectValue] = useState([]);
    const [workClassification, setWorkClassification] = useState([]);
    const [typeTransfer, setTypeTransfer] = useState([]);
    const [sectors, setSectors] = useState([]);
    const [annualProfitMargin, setAnnualProfitMargin] = useState([]);
    const [regionOptions, setRegionOptions] = useState([]);
    const [businessUnit, setBusinessUnit] = useState([]);
    const [currency, setCurrency] = useState('');
    const [frameworkData, setFrameworkData] = useState([]);
    const [currentDate, setCurrentDate] = useState('');
    const [pricingPlan, setPricingPlan] = useState("");
    const [tabPermissions, setTabPermissions] = useState({});
    const [frameSummaryTab, setFrameSummaryTab] = useState('');
    const [frameworkClientTab, setFrameworkClientTab] = useState('');
    const [frameworkSectionClient, setFrameworkSectionClient] = useState([]);
    const [frameworkFieldsClient, setFrameworkFieldsClient] = useState([]);
    const [frameworkSectionsProject, setFrameworkSectionsProject] = useState([]);
    const [frameworkProjectTab, setFrameworkProjectTab] = useState('');
    const [frameworkSectionsSummary, setFrameworkSectionsSummary] = useState([]);
    const [frameworkFieldsSummary, setFrameworkFieldsSummary] = useState([]);
    const [fwSummaryTooltip, setFwSummaryTooltip] = useState([]);
    const [frameworkFieldsNew, setFrameworkFieldsNew] = useState([]);
    const [frameworkModulesClone, setFrameworkModulesClone] = useState([]);
    const [clientFieldsNew, setClientFieldsNew] = useState([]);
    const [clientFieldsSummary, setClientFieldsSummary] = useState([]);
    const [commanFields, setCommanFields] = useState([]);
    const [frameworkClientTable, setFrameworkClientTable] = useState([]);
    const [frameworkProjectTable, setFrameworkProjectTable] = useState([]);
    const [clientData, setClientData] = useState([]);
    const [projectFieldsSummary, setProjectFieldsSummary] = useState([]);
    const [projectFieldsNew, setProjectFieldsNew] = useState([]);
    const [loading, setLoading] = useState(false);
    const [referenceData, setReferenceData] = useState([]);
    const [open, setopen] = useState(true);
    const [newItems, setNewItems] = useState([]);

    const { globalProgrammeData, setGlobalProgrammeData } = useProgramme();
    const { globalSidebarData } = useSidebar();
    const navigate = useNavigate()
    const toastRef = useRef();
    const location = useLocation();

    const enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const userprivileges = localStorage.getItem("user_privileges");
    if (userprivileges) {
        var tmpPrivilege = JSON.parse(userprivileges);
        if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
            var frameworkPrivilege = tmpPrivilege[0].framework_readwrite;
        }
    }

    useEffect(() => {
        setGlobalProgrammeData(frameworkData);
    }, [frameworkData]);

    useEffect(() => {
        if (frameworkId) {
            getFrameworkData()
        }
    }, [frameworkId])

    useEffect(() => {
        getCustomerData()
        getUsers()
        getCustomerDetails()
        initialgetFields()
        initialgetTables()
    }, [])

    useEffect(() => {
        if (pricingPlan) {
            getModulePermission()
        }
    }, [pricingPlan])

    useEffect(() => {
        if (referenceData.length > 0) {
            var tabs = [
                {
                    label: frameSummaryTab,
                    icon: "pi pi-list",
                    Component: (
                        <Summary
                            fieldData={{
                                "frameworkSectionsSummary": frameworkSectionsSummary,
                                "frameworkFieldsSummary": frameworkFieldsSummary,
                                "frameworkFieldsNew": frameworkFieldsNew,
                                "commanFields": commanFields
                            }}
                            fwSummaryTooltip={fwSummaryTooltip}
                            frameworkData={frameworkData}
                            currency={currency}
                            currentDate={currentDate}
                            options={{
                                "framework": framework,
                                "appointmentType": appointmentType,
                                "frameworkSize": frameworkSize,
                                "frameworkType": frameworkType,
                                "frameworkClassification": frameworkClassification,
                                "durations": durations,
                                "region": region,
                                "locations": locations,
                                "noOfCompetitors": noOfCompetitors,
                                "userDetails": userDetails,
                                "annualValueRational": annualValueRational,
                                "averageProjectValue": averageProjectValue,
                                "workClassification": workClassification,
                                "typeTransfer": typeTransfer,
                                "sectors": sectors,
                                "annualProfitMargin": annualProfitMargin,
                                "regionOptions": regionOptions,
                                "businessUnit": businessUnit
                            }}
                        />
                    ),
                },
                {
                    label: frameworkClientTab,
                    icon: "pi pi-desktop",
                    Component: (
                        <Stakeholder
                            fieldData={{
                                "frameworkSectionClient": frameworkSectionClient,
                                "frameworkClientTable": frameworkClientTable,
                                "frameworkFieldsClient": frameworkFieldsClient,
                                "frameworkClientTab": frameworkClientTab,
                                "clientFieldsNew": clientFieldsNew,
                                "clientFieldsSummary": clientFieldsSummary,
                                "commanFields": commanFields
                            }}
                            clientData={clientData}
                            frameworkData={frameworkData}
                            frameworkId={frameworkId}
                            currency={currency}
                        />
                    ),
                },
                {
                    label: frameworkProjectTab,
                    icon: "pi pi-file",
                    Component: (
                        <Project
                            fieldData={{
                                "frameworkSectionsProject": frameworkSectionsProject,
                                "frameworkProjectTable": frameworkProjectTable,
                                "projectFieldsSummary": projectFieldsSummary,
                                "projectFieldsNew": projectFieldsNew,
                                "clientFieldsNew": clientFieldsNew,
                                "commanFields": commanFields
                            }}
                            frameworkId={frameworkId}
                            currency={currency}
                        />
                    ),
                }
            ]
            var newItems = [];
            if (tabPermissions["Summary"]) {
                newItems.push(tabs[0]);
            }
            if (tabPermissions["Client"]) {
                newItems.push(tabs[1]);
            }
            if (tabPermissions["Project"]) {
                newItems.push(tabs[2]);
            }
            setItems(newItems)
        }
    }, [tabPermissions, referenceData, clientData])

    useEffect(() => {
        if (location.state) {
            setFrameworkId(location.state.framework_id);
        }
    }, [location.state]);

    const getUsers = async () => {
        try {
            setLoading(true)
            var userData = await allUsers(tmpData.customer, "firstname", 1, tmpData.branch)
            if (userData && userData.data) {
                setUserDetails(userData.data)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const getCustomerData = async () => {
        try {
            setLoading(true)
            var customerData = await getCust(tmpData.customer)
            if (customerData && customerData.data) {
                var referenceData = customerData.data.reference_data;
                referenceData.forEach((item) => {
                    if (item.option_names === "RegionV1") {
                        setRegion(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "Framework") {
                        setFramework(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "FrameworkClassification") {
                        setFrameworkClassification(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "FrameworkSize") {
                        setFrameworkSize(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "AppointmentType") {
                        setAppointmentType(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "FrameworkType") {
                        setFrameworkType(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "Durations") {
                        setDurations(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "Locations") {
                        var activeLocations = item.option_choice.filter((option) => option.status === 'active');
                        var tmpLocation = [];
                        for (var j = 0; j < activeLocations.length; j++) {
                            tmpLocation.push({ 'label': item.option_choice[j].label, '_id': item.option_choice[j]._id });
                        }
                        setLocations(tmpLocation);
                    } else if (item.option_names === "NoOfCompetitorsV2") {
                        setNoOfCompetitors(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "AnnualValueRational") {
                        setAnnualValueRational(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "AverageProjectValue") {
                        setAverageProjectValue(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "WorkClassificationV2") {
                        setWorkClassification(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "TypeTransfer") {
                        setTypeTransfer(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "SectorsInvolved") {
                        var activeLocations = item.option_choice.filter((option) => option.status === 'active');
                        var tmpSector = [];
                        for (var j = 0; j < activeLocations.length; j++) {
                            tmpSector.push({ 'label': item.option_choice[j].label, '_id': item.option_choice[j]._id, 'status': item.option_choice[j].status });
                        }
                        setSectors(tmpSector);
                    } else if (item.option_names === "AnnualProfitMargin") {
                        setAnnualProfitMargin(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "Region") {
                        setRegionOptions(item.option_choice.filter((option) => option.status === 'active'));
                    } else if (item.option_names === "BusinessUnit") {
                        setBusinessUnit(item.option_choice.filter((option) => option.status === 'active'));
                    }
                });
                setReferenceData(referenceData)
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: "An error occurred while fetching customer data. Please try again or contact Admin.",
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const getCustomerDetails = async () => {
        try {
            setLoading(true)
            var customerDataResponse = await getCustomer(tmpData.customer);
            if (customerDataResponse && customerDataResponse.data) {
                setPricingPlan(customerDataResponse.data.pricing_plan);
                var toolTipData = customerDataResponse.data.tooltips;
                setFwSummaryTooltip(toolTipData?.framework?.summary);
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: "An error occurred while getting customer Data. Please try again or contact Admin.",
                });
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const initialgetFields = async () => {
        try {
            setLoading(true)
            var fieldData = await getField(tmpData.customer)
            if (fieldData && fieldData?.data) {
                var clientModuleData = fieldData.data;
                var clientModules = _.find(clientModuleData.cust[0].modules, { module_name: "Clients", status: true });
                var clientFieldsNew = _.find(clientModules.sub_modules, { sub_module_name: "NEW" }).fields;
                setClientFieldsNew(clientFieldsNew)
                var clientFieldsSummary = _.find(clientModules.sub_modules, { sub_module_name: "Summary" }).fields;
                setClientFieldsSummary(clientFieldsSummary)

                var frameworkModules = _.find(clientModuleData.cust[0].modules, { module_name: "Frameworks", status: true });
                var frameworkModulesClone = frameworkModules.display_name
                setFrameworkModulesClone(frameworkModulesClone)
                var frameworkFieldNew = _.find(frameworkModules.sub_modules, { sub_module_name: "NEW" }).fields;
                setFrameworkFieldsNew(frameworkFieldNew)
                var frameworkSummaryTab = _.find(frameworkModules.sub_modules, { sub_module_name: "Summary" }).display_name;
                setFrameSummaryTab(frameworkSummaryTab)
                var frameworkFieldSummary = _.find(frameworkModules.sub_modules, { sub_module_name: "Summary" }).fields;
                setFrameworkFieldsSummary(frameworkFieldSummary)
                var frameworkSectionSummary = _.find(frameworkModules.sub_modules, { sub_module_name: "Summary" }).sections;
                setFrameworkSectionsSummary(frameworkSectionSummary)
                var frameworkClientTab = _.find(frameworkModules.sub_modules, { sub_module_name: "Client" }).display_name;
                setFrameworkClientTab(frameworkClientTab)
                var frameworkSectionClient = _.find(frameworkModules.sub_modules, { sub_module_name: "Client" }).sections;
                setFrameworkSectionClient(frameworkSectionClient)
                var frameworkFieldsClient = _.find(frameworkModules.sub_modules, { sub_module_name: "Client" }).fields;
                setFrameworkFieldsClient(frameworkFieldsClient)
                var frameworkSectionsProject = _.find(frameworkModules.sub_modules, { sub_module_name: "Project" }).sections;
                setFrameworkSectionsProject(frameworkSectionsProject)
                var frameworkProjectTab = _.find(frameworkModules.sub_modules, { sub_module_name: "Project" }).display_name;
                setFrameworkProjectTab(frameworkProjectTab)
                var commonModules = _.find(clientModuleData.cust[0].modules, { module_name: "Common Fields", status: true });
                var commonFields = _.find(commonModules.sub_modules, { sub_module_name: "Common Fields" }).fields;
                setCommanFields(commonFields)

                var projectModules = _.find(clientModuleData.cust[0].modules, { module_name: "Pipeline", status: true });
                var projectFieldsNew = _.find(projectModules.sub_modules, { sub_module_name: "NEW" }).fields;
                setProjectFieldsNew(projectFieldsNew)
                var projectFieldsSummary = _.find(projectModules.sub_modules, { sub_module_name: "Summary" }).fields;
                setProjectFieldsSummary(projectFieldsSummary)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const initialgetTables = async () => {
        try {
            setLoading(true)
            var tabledData = await getTable(tmpData.customer)
            if (tabledData && tabledData.data) {
                var frameworkModuleDataTables = tabledData.data;
                var frameworkFieldsTable = _.find(frameworkModuleDataTables.cust[0].modules, { module_name: "Frameworks", status: true });
                var frameworkClientTable = _.find(frameworkFieldsTable.sub_modules, { sub_module_name: "Client" }).tables;
                setFrameworkClientTable(frameworkClientTable)
                var frameworkProjectTable = _.find(frameworkFieldsTable.sub_modules, { sub_module_name: "Project" }).tables;
                setFrameworkProjectTable(frameworkProjectTable)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const getModulePermission = async () => {
        try {
            setLoading(true)
            if (pricingPlan) {
                const res = await getModulePermissions(pricingPlan, "Frameworks");
                if (res && res.data) {
                    const modulePermissions = res.data;
                    if (modulePermissions.status && modulePermissions.sub_modules) {
                        var tabPermissions = {};
                        _.filter(modulePermissions.sub_modules, (sub_module) => {
                            tabPermissions[sub_module.module_name] = sub_module.status;
                        });
                        setTabPermissions(tabPermissions);
                    }
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    };

    const findNoOfMonths = (d1, d2) => {
        var date1 = new Date(d1);
        var date2 = new Date(d2);
        var Nomonths;
        Nomonths = (date2.getFullYear() - date1.getFullYear()) * 12;
        Nomonths += date2.getMonth() - date1.getMonth();
        return Nomonths < 0 ? 0 : Nomonths;
    }

    const calcFrameworkPeriod = (current_date, framework_end_date) => {
        if (!_.isUndefined(framework_end_date)) {
            var start_date = current_date;
            var end_date = moment(framework_end_date, "DD.MM.YYYY").toDate();
            var framework_period_remaining = findNoOfMonths(start_date, end_date) + " Month(s)";
            setFrameworkData((prevData) => ({
                ...prevData,
                summary: {
                    ...prevData.summary,
                    framework_period_remaining: framework_period_remaining
                }
            }));
        }
    }

    const getFrameworkData = async () => {
        try {
            setLoading(true)
            var frameworkData = await get(frameworkId, tmpData.customer)
            if (frameworkData && frameworkData.data) {
                var frmData = frameworkData.data.framework;
                var current_date = frameworkData.data.current_date;
                setCurrentDate(current_date)
                var frameworkData = frmData;
                var fid = frameworkData._id
                frameworkData.next_review = (!_.isUndefined(frameworkData.next_review)) ? moment(frameworkData.next_review).format('DD-MM-YYYY') : frameworkData.next_review;
                setFrameworkData(frameworkData)
                var cllength = frmData.clients.length;
                var clindex = cllength - 1;
                var clientID = frameworkData.clients[clindex];
                var clientDetails = await findFrom(frameworkId)
                if (clientDetails && clientDetails.data) {
                    if (!_.isEmpty(clientDetails.data)) {
                        var clientData = clientDetails.data;
                        setClientData(clientData)
                    }
                }
                if (!_.isUndefined(frameworkData.summary.framework_end_date)) {
                    calcFrameworkPeriod(current_date, frameworkData.summary.framework_end_date.text)
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const updates = (e) => {
        setActiveIndex(e.index);
    };

    const validateDate = (startDate, endDate) => {
        var startDateSplited = startDate.split('-');
        var endDateSplited = endDate.split('-');
        var startDate = new Date(startDateSplited[1] + '/' + startDateSplited[0] + '/' + startDateSplited[2]);
        var endDate = new Date(endDateSplited[1] + '/' + endDateSplited[0] + '/' + endDateSplited[2]);
        if (startDate < endDate) {
            return true;
        }
        return false;
    }

    const saveProgramme = async () => {
        try {
            setLoading(true)
            setIsEdited(false);
            if (!_.isUndefined(globalProgrammeData.summary)) {
                let isValidDate
                if (!_.isUndefined(globalProgrammeData.summary.framework_start_date) && !_.isUndefined(globalProgrammeData.summary.framework_end_date)) {
                    isValidDate = validateDate(globalProgrammeData.summary.framework_start_date.text, globalProgrammeData.summary.framework_end_date.text);
                }
                if (isValidDate) {
                    if (frameworkPrivilege == config[0].readOnly) {
                        toastRef.current.showToast({
                            type: "error",
                            message: "Permission Denied"
                        });
                    } else if (frameworkPrivilege == config[1].readWrite) {
                        var updateData = await update(frameworkId, tmpData.customer, globalProgrammeData)
                        if (updateData && updateData.data) {
                            getFrameworkData();
                            toastRef.current.showToast({
                                type: "success",
                                message: frameworkModulesClone + "  Updated Successfully!"
                            });
                        } else {
                            toastRef.current.showToast({
                                type: "error",
                                message: updateData.data.message
                            });
                        }
                    }
                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: "Enter Valid Start Date & End Date"
                    });
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const handleScrollClick = (event) => {
        event.preventDefault();
        scrollToTop();
    };

    useEffect(() => {
        if (!open) {
            if (items.length > 0) {
                var newItems = [];
                items.forEach((item) => {
                    var icons = {
                        icon: item.icon,
                        Component: item.Component,
                    };
                    newItems.push(icons);
                    setNewItems(newItems);
                });
            }
        }
    }, [open]);

    const toggleOpen = (data) => {
        setopen(data);
    };

    return (
        <>
            <div ref={targetRef} className="target-div" ></div>
            <div className="mt-20">
                <ButtonElement className="scroll-top save-button" title="Scroll to Top" icon="pi pi-arrow-up" onClick={handleScrollClick} />
                <ToastElement ref={toastRef} />
                <Loader loading={loading} />
                <div className="flex justify-content-between">
                    <div>
                        <p className="fs-16 fw-600 mar-b-3">{frameworkData.framework_name}</p>
                    </div>
                    <div>
                        <ButtonElement
                            type="button"
                            className="save-button"
                            label="Save"
                            onClick={saveProgramme}
                        />
                    </div>
                </div>
                <div className={open ? "portfolio-tabs" : !globalSidebarData ? "portfolio-tabs collapse-tabs" : "portfolio-tabs collapse-tabs"}>
                    <TabElement
                        items={open ? items : newItems}
                        activeIndex={activeIndex}
                        onTabChange={(e) => updates(e)}
                        openTab={open}
                        setOpen={toggleOpen}
                        mainModules={true}
                    />
                    {/* <TabMenuElement items={items} activeIndex={activeIndex} onTabChange={(e) => updates(e)} /> */}
                </div>
                <div>
                    {/* {items && <div className='mt-10'>
                    {items[activeIndex] && items[activeIndex].Component}
                    </div>} */}
                </div>
            </div>
        </>
    )
}

export default ProgrammeTabs